import { render, staticRenderFns } from "./bp.vue?vue&type=template&id=a7453b62&scoped=true&"
import script from "./bp.vue?vue&type=script&lang=js&"
export * from "./bp.vue?vue&type=script&lang=js&"
import style0 from "./bp.vue?vue&type=style&index=0&id=a7453b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7453b62",
  null
  
)

export default component.exports